import {
  DashboardOutlined,
  GroupOutlined,
  HelpOutline,
  HomeRepairServiceOutlined,
  LanguageOutlined,
  OndemandVideo
} from '@mui/icons-material'
import { INTERCOM_NAV_HELP_LINK } from '@app/common/src/constants/Nav'
import { MoreSheetOptionType } from './types'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import React from 'react'

export const VIDEO_OPTION: MoreSheetOptionType = {
  header: 'Video',
  subheader: 'Add codes to video and TV templates',
  icon: <OndemandVideo />
}

export const UNIFIED_TEMPLATES_DISCOVER_MOBILE_OPTION: MoreSheetOptionType = {
  header: 'Templates',
  subheader: 'Create codes, pages and placements with templated designs',
  icon: <DashboardOutlined />,
  href: Routes.TEMPLATES_DISCOVER
}

export const UNIFIED_YOUR_TEMPLATES_MOBILE_OPTION: MoreSheetOptionType = {
  header: 'Templates',
  subheader: 'Create codes, pages and placements with templated designs',
  icon: <DashboardOutlined />,
  href: Routes.TEMPLATES_YOUR_TEMPLATES
}

export const UNIFIED_YOUR_TEMPLATES_CREATE_MOBILE_OPTION: MoreSheetOptionType = {
  header: 'Templates',
  subheader: 'Create codes, pages and placements with templated designs',
  icon: <DashboardOutlined />,
  href: Routes.TEMPLATES_YOUR_CREATE
}

export const DOMAINS_OPTION: MoreSheetOptionType = {
  header: 'Domains',
  subheader: 'Create and manage custom domains',
  icon: <LanguageOutlined />,
  href: Routes.DOMAINS
}

export const TEAMS_OPTION: MoreSheetOptionType = {
  header: 'Teams',
  subheader: 'Collaborate with your teammates',
  icon: <GroupOutlined />,
  href: Routes.MY_ORG_MEMBERS
}

export const INTERNAL_OPTION: MoreSheetOptionType = {
  header: 'Internal',
  subheader: 'Tools for Flowcode org members',
  icon: <HomeRepairServiceOutlined />
}

export const SUPPORT_OPTION: MoreSheetOptionType = {
  header: 'Support & Learn',
  subheader: 'Get help and browse support resources',
  icon: <HelpOutline />,
  href: INTERCOM_NAV_HELP_LINK,
  newTab: true
}

export const UPGRADE_UPSELL_COLOR = '#F8BB68' //seperate color to be easily interchangable
export const UPGRAGE_UPSELL_HOVER_COLOR = '#D27B30'
